import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Cookie from "js-cookie";
// import PropTypes from "prop-types";

const refreshToken = Cookie.get("refreshToken");

const AuthRedirectRoute = ({ component: Component, authorised, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authorised === false && !refreshToken ? (
        <Redirect to="/login" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

const mapStateToProps = (state) => ({
  authorised: state.provider.authorised,
});

// AuthRedirectRoute.propTypes = {
//   authenticates: PropTypes.bool.isRequired,
// };

export default connect(mapStateToProps, {})(AuthRedirectRoute);
